import { MealPlanAnalyticsLocation } from 'common/events/ClientEvents';
import React from 'react';
import { HeartToggleButton } from 'src/shared/design-system/HeartToggleButton';
import { useFavoriteFoodItemButton } from './hooks/useFavoriteFoodItemButton';

interface FavoriteFoodItemButtonProps {
  foodItemId: number;
  analyticsLocation: MealPlanAnalyticsLocation;
  dishName?: string;
  shefId?: string;
  cuisine?: string | null;
  /** Fires synchronously — caller drives the exit animation before the mutation resolves. */
  onAfterUnfavorite?: (foodItemId: number) => void;
  onAfterUndo?: (foodItemId: number) => void;
}

export const FavoriteFoodItemButton: React.FC<FavoriteFoodItemButtonProps> = ({
  foodItemId,
  analyticsLocation,
  dishName,
  shefId,
  cuisine,
  onAfterUnfavorite,
  onAfterUndo,
}) => {
  const { isFavorited, onClick } = useFavoriteFoodItemButton({
    foodItemId,
    location: analyticsLocation,
    dishName,
    shefId,
    cuisine,
    onAfterUnfavorite,
    onAfterUndo,
  });

  return <HeartToggleButton isActive={isFavorited} onToggle={onClick} className='size-12' />;
};
